import { boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Metadata } from './Metadata';
import { QuotedMessage } from './QuotedMessage';

export const Type = intersect(
	struct({
		id: string,
		channelId: string,
		channelArn: string,
		createdAt: string,
		createdBy: string,
	})
)(
	partial({
		clientId: string,
		text: string,
		deleted: boolean,
		lastEditedAt: string,
		metadata: Metadata,
		quotedMessage: QuotedMessage,
	})
);
